import Event from '../../core/Event';

export default class OrderPageEntered extends Event {
    public static type = 'OrderPageEntered';

    constructor() {
        super(OrderPageEntered.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/OrderPageEntered.ts